export default __webpack_public_path__ + "static/media/BreakingLive.28ff6610c8b155968eb6c5de38147b67.webp";